import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { HStack, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellOptionsContainer = (props: UpsellOptionsContainerProps) => {
  const { size, children } = props;
  const { match } = useResponsive();

  const containerStyle = [
    styles.container,
    size === 'lg' ? styles.containerLG : styles.containerMD,
  ];

  const itemsPerRow = match([1, 1, 2, 2]);

  return (
    <HStack
      itemsPerRow={itemsPerRow}
      gap={theme.spacing['10']}
      style={containerStyle}
    >
      {children}
    </HStack>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingTop: theme.spacing['8'],
    rowGap: theme.spacing['8'],
    paddingBottom: theme.spacing['6'],
  },
  containerMD: {
    paddingBottom: theme.spacing['8'],
  },
  containerLG: {
    paddingBottom: theme.spacing['12'],
  },
});

// ─────────────────────────────────────────────────────────────────────────────

type UpsellOptionsContainerProps = PropsWithChildren<{
  size: 'md' | 'lg';
}>;
